import { useIsCommercialSuretyEnabled } from "@portal/hooks/useIsCommercialSuretyEnabled";
import { useEffect } from "react";
import { type FieldValues, type Path, type UseFormReturn, useWatch } from "react-hook-form";
import {
	CONTRACT_ONLY_HISTORY_FIELD_PATHS,
	shouldShowContractHistoryQuestions,
} from "./contractHistoryQuestions";

export const useClearContractHistoryFields = <TFieldValues extends FieldValues>(
	formMethods: UseFormReturn<TFieldValues>,
) => {
	const isCommercialSuretyEnabled = useIsCommercialSuretyEnabled();
	const { control, unregister } = formMethods;
	const requiresPaymentAndPerformanceBonds = useWatch({
		control,
		name: "requiresPaymentAndPerformanceBonds" as Path<TFieldValues>,
	});

	useEffect(() => {
		if (
			shouldShowContractHistoryQuestions(
				isCommercialSuretyEnabled,
				requiresPaymentAndPerformanceBonds,
			)
		) {
			return;
		}

		unregister([...CONTRACT_ONLY_HISTORY_FIELD_PATHS] as Path<TFieldValues>[]);
	}, [isCommercialSuretyEnabled, requiresPaymentAndPerformanceBonds, unregister]);
};
